<template>
  <footer class="footer">
    <!-- <ul class="footer-list">
      <li>{{ `Reallang - ${year}` }}</li>

      <li>
        <f7-link href="https://reallang.com/" external target="_blank">
          Reallang School
        </f7-link>
      </li>
      <li>
        <f7-link href="https://reallang.com/apps/" external target="_blank">
          Reallang Apps
        </f7-link>
      </li>
      <li>
        <f7-link
          href="https://reallang.com/privacy-policy/"
          external
          target="_blank"
        >
          {{ $t(`privacy_policy`) }}
        </f7-link>
      </li>
      <li>
        <f7-link href="https://reallang.com/help/" external target="_blank">
          {{ $t(`contacts`) }}
        </f7-link>
      </li>
    </ul> -->
    <div>
      <ul class="footer-list footer-list-secondary">
        <!-- <li>
          <f7-link href="https://reallang.club/" external target="_blank">
            Educational Apps
          </f7-link>
        </li>
        <li>
          <f7-link href="https://reallang.com/" external target="_blank">
            Online Education
          </f7-link>
        </li> -->
        <li>
          <f7-link
            href="https://stillfy.com/terms-of-service.html"
            external
            target="_blank"
          >
            Terms
          </f7-link>
        </li>
        <li>
          <f7-link
            href="https://stillfy.com/contacts.html"
            external
            target="_blank"
          >
            Contacts
          </f7-link>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="less">
.footer {
  padding: 30px 15px;
  max-width: 768px;
  margin-right: auto;
  margin-left: auto;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-list {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  list-style: none;

  @media (max-width: 575.99px) {
    flex-wrap: wrap;
  }

  li {
    color: #a1a1a1;
    font-weight: 600;

    @media (max-width: 767.98px) {
      text-align: center;
    }

    @media (max-width: 575.99px) {
      margin-bottom: 10px;
      flex-basis: 50%;
      flex-grow: 1;
    }

    &:not(:last-of-type) {
      margin-right: 20px;

      @media (max-width: 575.99px) {
        margin-right: 0;
      }
    }
  }

  a {
    color: #000000;
  }
}

.footer-list-secondary {
  a {
    color: #a1a1a1;
  }
}
</style>
